import {makeStyles} from '@material-ui/core';

export default makeStyles((theme) => (
    {
        cont: {
            marginTop: theme.spacing(5)
           
        },
        avatar: {
            padding: theme.spacing(2),
            height: theme.spacing(8),
            width: theme.spacing(8)
        },
        img: {
            display: "inlineblock"
        }
    }
));